import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class EstoqueAtualPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { buscaProduto, buscaMarca, buscaGrupo, buscaSituacao, buscaEstoqueBaixo } = this.props.filtros;

        axios
            .get('/estoque/listaEstoqueAtual', {
                params: {
                    print: true,
                    produto: buscaProduto.pest_item,
                    tamanho: buscaProduto.pest_tamanho,
                    cor: buscaProduto.pest_cor,
                    marca: buscaMarca.key,
                    grupo: buscaGrupo.key,
                    situacao: String(buscaSituacao.key),
                    estoqueBaixo: buscaEstoqueBaixo
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.consulta,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderValorCusto = (registro) => {
        return (
            <span> {numeral(parseFloat(registro.pest_qtde) * parseFloat(registro.prod_vlr_custo)).format('0,000.00')} </span>
        );
    };

    renderValorVenda = (registro) => {
        return (
            <span> {numeral(parseFloat(registro.pest_qtde) * parseFloat(registro.prod_vlr_venda)).format('0,000.00')} </span>
        );
    };

    renderSituacao = (prod_situacao) => {
        return (
            <span> {prod_situacao === 1 ? 'ATIVO' : 'INATIVO'} </span>
        );
    };


    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Estoque Atual
                        </div>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            rowKey={(listaRegistros => listaRegistros.prod_codigo + '_' + listaRegistros.pest_tamanho + '_' + listaRegistros.pest_cor)}
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="prod_codigo"
                                dataIndex="prod_codigo"
                                title="Código"
                                width={60}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="prod_descricao"
                                dataIndex="prod_descricao"
                                title="Descrição"
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="mar_descricao"
                                dataIndex="mar_descricao"
                                title="Marca"
                                width={80}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="grp_descricao"
                                dataIndex="grp_descricao"
                                title="Grupo"
                                width={80}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="prod_situacao"
                                dataIndex="prod_situacao"
                                title="Sit."
                                width={60}
                                align="left"
                                className="listaCadastro"
                                render={this.renderSituacao}
                            />
                            <Column
                                key="pest_qtde"
                                dataIndex="pest_qtde"
                                title="Qtde Atual"
                                width={90}
                                align="right"
                                className="listaCadastro"
                                render={this.renderValor}
                            />
                            <Column
                                key="prod_vlr_custo"
                                dataIndex="prod_vlr_custo"
                                title="Vlr Custo"
                                width={80}
                                align="right"
                                className="listaCadastro"
                                render={this.renderValor}
                            />
                            <Column
                                // key="prod_vlr_custo"
                                // dataIndex="prod_vlr_custo"
                                title="Total Custo"
                                width={90}
                                align="right"
                                className="listaCadastro"
                                render={this.renderValorCusto}
                            />
                            <Column
                                key="prod_vlr_venda"
                                dataIndex="prod_vlr_venda"
                                title="Vlr Venda"
                                width={80}
                                align="right"
                                className="listaCadastro"
                                render={this.renderValor}
                            />
                            <Column
                                // key="prod_vlr_venda"
                                // dataIndex="prod_vlr_venda"
                                title="Total Venda"
                                width={90}
                                align="right"
                                className="listaCadastro"
                                render={this.renderValorVenda}
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default EstoqueAtualPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/EstoqueAtualPrintModal.js